import Color from 'color';
import styled, {css} from 'styled-components';

import VoiceOffIcon from '../../../../assets/icons/primary/Voice off.svg';
import {ms} from '../../../../styles/normalizeSize';
import {getColor, square} from '../../../../styles/utils';
import {Image} from '../../../../uikit/Image';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const containerStyle = css<{isVerticalVideo: boolean}>`
  flex: 1;
  background: ${p => Color(getColor('static.white')(p)).alpha(0.1).toString()};
  border-radius: ${ms(8)};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${() =>
    platform.isWeb &&
    css`
      width: 100%;
      height: 100%;
    `}

  video {
    object-fit: ${p => (p.isVerticalVideo ? 'contain' : 'cover')} !important;
    height: 100% !important;
  }
`;

export const MuteIcon = styled(VoiceOffIcon).attrs<{$isCoach: boolean}>(p => ({
  fill: getColor(p.$isCoach ? 'icon.white' : 'icon.red')(p),
}))<{$isCoach: boolean}>`
  ${square(16)}
`;

export const NameWrapper = styled(View)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${ms(10)};
  padding: 0 ${ms(10)};
`;

export const NameContainer = styled(View)<{
  isCoach: boolean;
}>`
  height: ${ms(20)};
  padding: 0 ${ms(8)};
  background-color: ${p =>
    Color(getColor('static.black')(p)).alpha(0.6).toString()};
  border-radius: ${ms(10)};
  align-items: center;
  overflow: hidden;
  flex-direction: row;
  align-self: flex-start;
  gap: ${ms(4)};

  ${p =>
    p.isCoach &&
    css`
      background-color: ${Color(getColor('global1')(p)).alpha(0.6).toString()};
    `}
`;

export const HostWrapper = styled(NameWrapper)`
  /* name bottom pos + name height + gap */
  bottom: ${ms(10 + 20 + 4)};
`;

export const HostContainer = styled(NameContainer)`
  background-color: ${p => Color(getColor('global2')(p)).alpha(0.6).toString()};
`;

export const Name = styled(Text).attrs({
  nativeProps: {
    numberOfLines: 1,
  },
  weight: 'semibold',
})`
  font-size: ${ms(14)};
  line-height: ${ms(20)};
  color: ${getColor('text.white')};

  ${() =>
    platform.isNative &&
    css`
      flex-grow: 0;
      flex-shrink: 1;
    `}

  ${() =>
    platform.isWeb &&
    css`
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      min-width: 0;
      flex-grow: 1;
    `}
`;

export const Avatar = styled(Image)<{size: number}>`
  width: ${p => ms(p.size)};
  height: ${p => ms(p.size)};
  border-radius: ${p => ms(p.size)};

  ${() =>
    // prevents jumping UI when we toggle the video on/off
    platform.isWeb &&
    css`
      position: absolute;
    `}
`;

export const TalkingFrame = styled(View)`
  position: absolute;
  inset: 0;
  border: 2px solid ${getColor('global1')};
  border-radius: ${ms(8)};
`;

export const ChildrenContainer = styled(View)<{hasVideo: boolean}>`
  opacity: ${p => (p.hasVideo ? 1 : 0)};
  position: absolute;
  inset: 0;
`;
